import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';

import { media, rem, themed } from '@/shared/ui/core';
import { MenuButton, MenuWrapper } from '../../elements/menu/Menu.styled';

const modifiers = {
  isActive: ({ filterNumber, theme }) => ({
    styles: `
      .Text {
          color: ${theme.primary.main};

          &::after {
            content: " (${filterNumber})";
            display: inline;
          }
        }
      }

      svg {
        path {
          fill: ${theme.primary.main};
        }

        &:last-of-type {
          display: inline-block;
        }
      }
    `,
  }),
};

export const FiltersStyled = styled.div.attrs({
  className: 'FiltersStyled',
})`
  z-index: 1;

  .ReactCollapse--collapse {
    @media ${media.desktopMin} {
      height: auto !important;
      overflow: initial !important;
    }
  }

  .Title {
    display: none;
  }

  @media ${media.desktopMin} {
    width: 14rem;
    margin-left: 3.5rem;
    max-height: 100%;
    position: absolute;
    top: 2.75rem;
    left: 50%;
    transform: translateX(10.3rem);

    .Title {
      font-size: 1.125rem;
      padding: 0.8125rem;
      padding-bottom: 0;
      display: block;
      color: ${themed('primary.main')};
    }

    .SectionWrapper {
      padding: 0.8125rem;
      padding-bottom: 0;
    }

    .FilterWrapper .FilterSection {
      margin-bottom: 0;

      .FilterSummary {
        display: none;
      }
    }

    .InputWrapper {
      margin-right: 0;
    }
  }

  ${applyStyleModifiers(modifiers)}
`;

export const FilterHeader = styled.div.attrs({
  className: 'FilterHeader',
})`
  display: none;
  width: 100%;
  justify-content: space-between;

  .component__button {
    font-size: 1rem;
    text-decoration: underline;
    height: auto;
    width: auto;
    min-width: auto;
    background-color: transparent;
    padding: 0;
    border: none;
    margin-top: 0.8125rem;
    margin-right: 0.8125rem;
    color: ${themed('primary.main')};
  }

  @media ${media.desktopMin} {
    display: flex;
  }
`;

export const SectionWrapper = styled.div.attrs({
  className: 'SectionWrapper',
})`
  width: 100%;
  height: auto;
  padding: 1rem 1.25rem 0;
  position: relative;
`;

export const SectionFilter = styled.div`
  .SectionWrapper {
    padding: 0;

    @media ${media.mobileMin} {
      padding-right: 1.25rem;
      padding-left: 1.25rem;
    }

    @media ${media.desktopMin} {
      padding-right: 0.8125rem;
      padding-left: 0.8125rem;
    }
  }
`;

export const FilterSummary = styled.button.attrs({
  type: 'button',
  className: 'FilterSummary',
})`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SearchWrapper = styled.div`
  margin: 0 auto 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media ${media.desktopMin} {
    margin-bottom: 0.5rem;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid ${themed('common.borderColor')};
  }
`;

export const InputWrapper = styled.div.attrs({
  className: 'InputWrapper',
})`
  flex: 1;
  min-width: 0;
  position: relative;

  &:not(:last-of-type) {
    margin-right: 1rem;

    @media ${media.desktopMin} {
      margin-right: 0.5rem;
    }
  }

  input {
    margin-bottom: 0;
    appearance: none;
  }
`;

export const FilterWrapper = styled.div.attrs({
  className: 'FilterWrapper',
})`
  a {
    text-decoration: none;
  }

  ${MenuWrapper} {
    margin-left: ${rem(8)};

    @media ${media.desktopMin} {
      position: absolute;
      right: 14.5rem;
      top: -1.5rem;

      ${MenuButton} {
        font-size: ${rem(15)};
        font-weight: 600;
        min-width: ${rem(60)};
      }
    }
  }

  ${MenuButton} {
    padding-right: 0;
  }
`;

export const FilterSection = styled.div.attrs({
  className: 'FilterSection',
})`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 1rem;

  .FilterSummary {
    background: transparent;
    border: none;
    padding: 0;

    span {
      font-size: ${rem(14)};
      font-weight: ${themed('button.filter.fontWeight')};
      color: ${themed('primary.accent')};
    }

    svg {
      width: 1rem;
      height: 1rem;
      fill: ${themed('primary.accent')};
      display: block;
      margin-left: 0.5rem;
    }
  }

  > svg {
    &:last-of-type {
      display: none;
    }
  }

  ${applyStyleModifiers(modifiers)}
`;

export const SearchIconBtn = styled.button.attrs({
  className: 'SearchIconBtn',
})`
  cursor: pointer;
  z-index: 1;
  width: 2rem;
  height: 2rem;
  fill: #8e9da2;
  border: none;
  background-color: transparent;
  position: absolute;
  top: 50%;
  right: -0.5rem;
  transform: translate(-50%, -50%);

  svg {
    width: 1rem;
    height: 1rem;
    fill: #8e9da2;
    position: absolute;
    top: 50%;
    right: -0.2rem;
    transform: translate(-50%, -50%) rotateY(180deg);
  }
`;

export const ShiftModalButton = styled.button.attrs({
  className: 'ShiftModalButton',
})`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: fit-content;
  position: absolute;
  top: ${rem(15)};
  background-color: transparent;
  border: none;
  padding: 0;
  cursor: pointer;

  .Text {
    font-size: ${rem(14)};
    font-weight: bold;
    color: ${themed('primary.main')};
    max-width: calc(100vw - 10rem);
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    height: ${rem(20)};
    line-height: ${rem(20)};
  }

  svg {
    display: none;
    margin-left: 0.45rem;
  }

  @media (min-width: 360px) {
    svg {
      display: initial;
    }
  }

  @media ${media.desktopMin} {
    top: -1.5rem;
    right: 19.5rem;
    justify-content: flex-end;
    width: 200px;

    .Text {
      font-size: ${rem(15)};
    }
  }
`;
